export const MESSAGE_COLOR_OPTIONS = [
  {
    value: "orange",
    label: "Orange",
    iconStart: "./assets/blockicons/LetterGet_Orange.svg",
    iconSend: "./assets/blockicons/LetterSend_Orange.svg",
  },
  {
    value: "red",
    label: "Red",
    iconStart: "./assets/blockicons/LetterGet_Red.svg",
    iconSend: "./assets/blockicons/LetterSend_Red.svg",
  },
  {
    value: "yellow",
    label: "Yellow",
    iconStart: "./assets/blockicons/LetterGet_Yellow.svg",
    iconSend: "./assets/blockicons/LetterSend_Yellow.svg",
  },
  {
    value: "blue",
    label: "Blue",
    iconStart: "./assets/blockicons/LetterGet_Blue.svg",
    iconSend: "./assets/blockicons/LetterSend_Blue.svg",
  },
  {
    value: "green",
    label: "Green",
    iconStart: "./assets/blockicons/LetterGet_Green.svg",
    iconSend: "./assets/blockicons/LetterSend_Green.svg",
  },
  {
    value: "purple",
    label: "Purple",
    iconStart: "./assets/blockicons/LetterGet_Purple.svg",
    iconSend: "./assets/blockicons/LetterSend_Purple.svg",
  },
];

export const DEFAULT_MESSAGE_COLOR = "orange";

const MESSAGE_COLOR_LOOKUP = MESSAGE_COLOR_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

export function normalizeMessageColor(color) {
  if (!color || typeof color !== "string") return DEFAULT_MESSAGE_COLOR;
  const lowered = color.toLowerCase();
  return MESSAGE_COLOR_LOOKUP[lowered] ? lowered : DEFAULT_MESSAGE_COLOR;
}

export function getMessageIconPath(blockType, color) {
  const normalized = normalizeMessageColor(color);
  const option = MESSAGE_COLOR_LOOKUP[normalized] || MESSAGE_COLOR_LOOKUP[DEFAULT_MESSAGE_COLOR];
  if (!option) return "";
  return blockType === "startOnMessage" ? option.iconStart : option.iconSend;
}
